import { render } from "./TabsItem.vue?vue&type=template&id=2156d8cd"
import script from "./TabsItem.vue?vue&type=script&lang=js"
export * from "./TabsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__